export enum FlightsViews {
  TRIP_TYPE = "flight-listing-triptype",
  FILTERED = "flight-listing-filtered",
  FARE_TABLE = "fare-table",
  BAR_CHART = "fare-calendar-barchart",
  SLIM_LISTING = "slim-listing",
}

export enum TripType {
  ONE_WAY = "ONE_WAY",
  ROUND_TRIP = "ROUND_TRIP",
}
